import React from 'react';
import { APITypes, Dynamo } from '../../../primary-record-types';
import { getIntl } from '../../../utils/intl';
import * as Filtering from '../../shared/Filtering';

const intl = getIntl('CareTeamMemberTypeFilter', {
    all: 'All',
    'support-care-team-member': 'Support',
    'provider-care-team-member': 'Provider',
    'insurance-care-team-member': 'Insurance',
    type: 'Type',
});

export type CareTeamMemberTypeFilterValue = Dynamo.CareTeamMemberContactType | 'all';

export type CareTeamMemberTypeFilterOwnProps = {
    value: CareTeamMemberTypeFilterValue;
    onChange: (value: CareTeamMemberTypeFilterValue) => void;
    allCareTeamMembers: APITypes.medicalProfileService.CareTeamMemberDetails[];
};

export type CareTeamMemberTypeFilterProps = CareTeamMemberTypeFilterOwnProps;

export const applyTypeFilter = (
    careTeamMembers: APITypes.medicalProfileService.CareTeamMemberDetails[],
    filterValue: CareTeamMemberTypeFilterValue,
) => {
    if (filterValue === 'all') return careTeamMembers;
    return careTeamMembers.filter((member) => member.contactDetails.contactType === filterValue);
};

const CareTeamMemberTypeFilter: React.FC<CareTeamMemberTypeFilterProps> = ({ value, onChange, allCareTeamMembers }) => {
    const getCount = (type: CareTeamMemberTypeFilterValue) => {
        if (type === 'all') return allCareTeamMembers.length;

        return allCareTeamMembers.filter((member) => member.contactDetails.contactType === type).length;
    };

    const optionValues = [
        'all',
        'provider-care-team-member',
        'support-care-team-member',
        'insurance-care-team-member',
    ] as const;
    return (
        <Filtering.SelectFilter
            value={value}
            onChange={(value) => onChange(value as CareTeamMemberTypeFilterValue)}
            options={optionValues.map((value) => ({
                value,
                label: intl(value),
                count: getCount(value),
            }))}
            onClear={value !== 'all' ? () => onChange('all' as CareTeamMemberTypeFilterValue) : undefined}
            title={intl('type')}
        />
    );
};

export default React.memo(CareTeamMemberTypeFilter);
